import { createClient } from "@supabase/supabase-js";

export interface AdminSupabaseConfig {
  supabaseUrl: string;
  publishableKey: string;
}

export function createAdminSupabaseClient({ supabaseUrl, publishableKey }: AdminSupabaseConfig) {
  return createClient(supabaseUrl, publishableKey, {
    auth: {
      autoRefreshToken: true,
      // Password-reset links land with recovery tokens in the URL hash.
      detectSessionInUrl: true,
      persistSession: true,
    },
  });
}

let sharedClient: ReturnType<typeof createAdminSupabaseClient> | null = null;

/**
 * One client per page: the admin app and the act-as token listener share this
 * instance so two GoTrueClients never race each other over the same persisted
 * session (refresh-token rotation makes a lost race a signed-out admin).
 */
export function getAdminSupabaseClient(config: AdminSupabaseConfig) {
  if (!sharedClient) sharedClient = createAdminSupabaseClient(config);
  return sharedClient;
}
